/*
 * @Author: mark
 * @Date: 2022-02-24 10:06:07
 * @LastEditors: zhangyigong 947028660@qq.com
 * @LastEditTime: 2022-05-06 09:47:29
 */
import { defineStore } from "pinia";
import { CmsDetail } from "@/utils/CmsUtil";
import { selCms, selCmsMenu } from "@/api/index";
export const userStore = defineStore({
  id: "userStore",
  state: () => ({
    cmsDetail: new CmsDetail(),
    cmsMenuList: Array<any>()
  }),
  actions: {
    async selCmsDetail() {
      if (
        this.cmsDetail.cmsName.length == 0 ||
        this.cmsDetail.cmsLogo.length == 0 ||
        this.cmsDetail.cmsTel.length == 0 ||
        this.cmsDetail.cmsAddress.length == 0 ||
        this.cmsDetail.cmsEmail.length == 0 ||
        this.cmsDetail.cmsVideo.length == 0
      ) {
        const cmsDetailParams = {
          item_code: "cms"
        };
        await selCms(cmsDetailParams)
          .then((res: any) => {
            if (res != null) {
              res.cms.filter((val: any) => {
                switch (val.item_code) {
                  case "CmsTel":
                    this.cmsDetail.cmsTel = val.item_value;
                    break;
                  case "CmsVideo":
                    this.cmsDetail.cmsVideo = val.item_value;
                    break;
                  case "CmsName":
                    this.cmsDetail.cmsName = val.item_value;
                    break;
                  case "CmsLogo":
                    this.cmsDetail.cmsLogo = val.item_value;
                    break;
                  case "CmsEmail":
                    this.cmsDetail.cmsEmail = val.item_value;
                    break;
                  case "CmsAddress":
                    this.cmsDetail.cmsAddress = val.item_value;
                    break;
                }
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    async selMenu() {
      if (this.cmsMenuList.length == 0) {
        const menuParams = {
          parent_id: "0",
          status: "1",
          orderType: "sort_code",
          orderRise: "true"
        };
        await selCmsMenu(menuParams)
          .then((res: any) => {
            if (res.data != null) {
              this.cmsMenuList = res.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }
});
